import {booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {DokumentAnnoteringId, DokumentVersjonModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {DomSanitizer} from "@angular/platform-browser";
import {MatIcon} from "@angular/material/icon";
import {MatMiniFabButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {KlientKapasiteter} from "felles-ng2/tjenester/KlientKapasiteter";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {lyttTilEsc} from "felles-ng2/støttefunksjoner/tastaturhendelser";
import {Meldingstype, PdfjsMeldingshåndtering} from "felles/tjenester/PdfjsMeldingshåndtering";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {filter} from "rxjs";
import {DokumentVisPdfIframeKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-vis-pdf-iframe/dokument-vis-pdf-iframe";
import {DokumentInformasjonTjeneste} from "felles-ng2/tjenester/DokumentInformasjonTjeneste";
import {åpneINyttvindu} from "felles-ng2/støttefunksjoner/nettleser";
import {KlikkMedStopPropagationDirektiv} from "web-ng2/delt/direktiver/klikkMedStopPropagation/klikkMedStopPropagation";

const debug = initDebugger('DokumentInlinePdfviserKomponent');

/**
 * inline visning av PDF-dokument vhja pdfjs-viser
 */
@Component({
    selector: 'dokument-inline-pdfviser',
    templateUrl: 'dokument-inline-pdfviser.html',
    styleUrl: 'dokument-inline-pdfviser.scss',
    host: {
        '[class.med-ramme]': 'medRamme()',
        '[class.vis-filnavn]': 'visFilnavn()',
        'data-testid': 'inline-pdfviser',
    },
    imports: [
        MatIcon,
        MatMiniFabButton,
        TranslateModule,
        InlineMeldingKomponent,
        DokumentVisPdfIframeKomponent,
        KlikkMedStopPropagationDirektiv
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentInlinePdfviserKomponent {

    /** Signaliserer at inline-visning skal lukkes */
    readonly vedLukk = output();

    readonly dokumentversjon = input.required<DokumentVersjonModell>();
    readonly forespurtAnnoteringId = input<DokumentAnnoteringId>();
    readonly visFilnavn = input(true, {transform: booleanAttribute});
    readonly medRamme = input(true, {transform: booleanAttribute});

    readonly informasjon = computed(() => this.dokumentInformasjon.dokumentinformasjon(this.dokumentversjon()));
    readonly dokumentUrl = computed(() => this.domSanitizer.bypassSecurityTrustResourceUrl(this.informasjon().standardformat.url));

    readonly stotterPdfJs: boolean;

    constructor(klientKapasiteter: KlientKapasiteter, private dokumentInformasjon: DokumentInformasjonTjeneste, private domSanitizer: DomSanitizer, pdfjsMeldingshåndtering:PdfjsMeldingshåndtering) {
        this.stotterPdfJs = klientKapasiteter.støtterPdfjs();

        pdfjsMeldingshåndtering.meldinger
          .pipe(
            filter(melding => melding.type == Meldingstype.åpneINyttVindu),
            takeUntilDestroyed())
          .subscribe(() => this.åpneINyFane())

        lyttTilEsc(() => this.lukk());
    }

    //privat hjelpemetoder

    private åpneINyFane(){
        const url = this.informasjon().pdfjsDokumentViserUrl;
        debug('åpner med pdfjs', url);
        åpneINyttvindu(url);

        this.lukk();
    }

    private lukk(){
        this.vedLukk.emit()
    }
}
